<div class="tooltip-outer">
  <div class="tooltip-trigger"
    [ngClass]="{'tooltip-trigger_hasTooltip': this.hasTooltip, 'tooltip-trigger_pointerEvents': this.disablePointerEvent}"
    [tooltip]="tooltipContent" [container]="this.container" [containerClass]="this.cssClass"
    [placement]="this.placement" [isDisabled]="!this.hasTooltip" [adaptivePosition]="this.adaptivePosition"
    [tooltipAnimation]="true" [boundariesElement]="this.boundaries">
    <ng-content></ng-content>
  </div>
</div>
<ng-template #tooltipContent>
  <div class="tooltip-content" [innerHtml]="text"
    [ngStyle]="minWidth !== 'none' && {'maxWidth': minWidth, 'whiteSpace': 'normal' }"></div>
</ng-template>
